<ng-container *ngFor="let step of steps; last as isLast; trackBy:identify">
	<cs-wizard-step [step]="step"
					[isLast]="isLast"
					[state]="step?.state"
	></cs-wizard-step>
</ng-container>
